<h1 mat-dialog-title>
  <mat-icon>error</mat-icon> {{ 'technicalDifficultiesDialog.title' | translate}}
</h1>

<div mat-dialog-content>
  <div [innerHtml]="'technicalDifficultiesDialog.message' | translate"></div>
</div>

<div mat-dialog-actions
     class="justify-content-end">
    <button mat-raised-button
            color="primary"
            (click)="onCloseDialog()">{{ 'technicalDifficultiesDialog.buttons.closeDialog' | translate}}</button>
</div>
